module.exports = __webpack_public_path__ + "img/logo-plataforma_web_400.5092c632.png";